import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { BrIconComponent } from '../../../shared/ui/icon/icon.component';
import { DynamicColumn, DynamicFieldValue } from './dynamic-framework.models';
import { parseWorkflowCsv } from './dynamic-workflow-csv';

export interface SmartWorkflowImportDialogData {
  workflowLabel: string;
  fields: DynamicColumn[];
}

@Component({
  selector: 'app-smart-workflow-import-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, BrIconComponent],
  templateUrl: './smart-workflow-import-dialog.component.html',
})
export class SmartWorkflowImportDialogComponent {
  fileName = '';
  rows: DynamicFieldValue[][] = [];
  errors: string[] = [];
  reading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: SmartWorkflowImportDialogData,
    private readonly dialogRef: MatDialogRef<
      SmartWorkflowImportDialogComponent,
      DynamicFieldValue[][]
    >,
  ) {}

  get activeFields(): DynamicColumn[] {
    return this.data.fields.filter(field => field.isActive);
  }

  async selectFile(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file) return;

    this.fileName = file.name;
    this.rows = [];
    this.errors = [];
    this.reading = true;
    try {
      const result = parseWorkflowCsv(await file.text(), this.activeFields);
      this.rows = result.rows;
      this.errors = result.errors;
      if (!this.rows.length && !this.errors.length) {
        this.errors = ['The CSV file does not contain any data rows.'];
      }
    } catch {
      this.errors = ['The CSV file could not be read.'];
    } finally {
      this.reading = false;
    }
  }

  import(): void {
    if (this.rows.length && !this.errors.length) this.dialogRef.close(this.rows);
  }
}
